<template>
  <div class="banner">
    <div class="logo-overlay"></div>
    <div class="d-flex">
      <h5>{{ $t("dashboard.onboardYourSchool") }}</h5>
      <eg-button
        type="ordinary"
        size="extra-small"
        icon="close"
        icon-size="medium"
        icon-color="var(--color-icon-surface-default)"
        @click="$emit('onClose')"
      />
    </div>

    <div class="banner-text">
      {{ bannerText }}
    </div>

    <social-proof />

    <div class="mt-4">
      <eg-button
        class="banner-button"
        type="primary"
        right-icon="arrow-right"
        :href="EXTERNAL_URLS.SCHOOL_TRIAL"
        target="_blank"
      >
        {{ $t("account.startNow") }}
      </eg-button>
    </div>
  </div>
</template>

<script>
import SocialProof from "@/components/global/onboardBanner/socialProof/social-proof.vue";
import { EXTERNAL_URLS } from "@/constants";

export default {
  name: "OnboardBanner",
  components: { SocialProof },

  data() {
    return {
      EXTERNAL_URLS,
    };
  },

  computed: {
    bannerText() {
      return this.$t("common.pleaseFillForm");
    },
  },
};
</script>

<style scoped lang="scss">
.banner {
  margin-top: auto;
  position: relative;
  background: radial-gradient(
      50% 50% at 50% 50%,
      #6a50f3 0%,
      rgba(62, 46, 141, 0.3) 100%
    ),
    linear-gradient(180deg, #6135c1 0%, #5d33b7 100%);
  border-radius: 12px;
  color: var(--color-surface-neutral-default);
  padding: 1rem;

  .logo-overlay {
    position: absolute;
    height: 130px;
    top: 30px;
    left: 0;
    right: 0;
    // TODO:Oleh: replace with SVG
    background: url("@/assets/eg-logo-tiny-transparent.png") center no-repeat;
    background-size: cover;
    opacity: 0.1;
  }

  .banner-text {
    font-size: var(--typography-font-size-fs-300);
    font-weight: var(--typography-font-weight-fw-500);
    margin-bottom: 32px;
    line-height: 150%;
    color: var(--color-text-on-surface-secondary);
  }

  .banner-button {
    width: 100%;
    background: #f6f2ff1a; //TODO: review it
    border-color: rgb(221, 185, 246, 0.7);
  }
}
</style>
